export function addHours(day: Date, hours: number): Date {
  return new Date(
    day.getFullYear(),
    day.getMonth(),
    day.getDate(),
    day.getHours() + hours,
    day.getMinutes(),
    day.getSeconds(),
    day.getMilliseconds()
  );
}
